<div class="calculator-profit-container">
  <ngx-app-bar
    class="w-100"
    [title]="'انتخاب روش سرمایه‌گذاری'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="calculator-profit-content">
    <app-calculated-info-card
      [fromDate]="cardInfo.fromDate"
      [toDate]="cardInfo.toDate"
      [amount]="cardInfo.amount"
    ></app-calculated-info-card>
    @if (funds) {
      <app-available-funds [funds]="funds"></app-available-funds>
    }
  </div>
</div>
